class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    // Track keyboard closes (Esc) so close() can tell them apart from
    // pointer closes; keydown fires before the keyup close handler below.
    this.closedByKeyboard = false;
    this.notification.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') this.closedByKeyboard = true;
    });

    // Remember where the pointer last was inside the notification so
    // close() can tell which product card sits under it.
    this.lastPointerPosition = null;
    this.notification.addEventListener('pointerup', (event) => {
      this.lastPointerPosition = { x: event.clientX, y: event.clientY };
    });

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    const opener = this.activeElement;
    // removeTrapFocus() refocuses the opener. When that's a card's hidden
    // "Choose Options" button (quick-add → add to cart → notification),
    // focus() scrolls the card's overflow-clipped containers — capture the
    // in-card scroll state and restore it after (same fix as cart-drawer.js).
    const openerCard = opener && opener.closest ? opener.closest('.card-wrapper') : null;
    const scrollState = [];
    if (openerCard) {
      for (let el = opener.parentElement; el; el = el.parentElement) {
        scrollState.push([el, el.scrollTop, el.scrollLeft]);
        if (el === openerCard) break;
      }
    }
    removeTrapFocus(this.activeElement);
    scrollState.forEach(([el, top, left]) => {
      el.scrollTop = top;
      el.scrollLeft = left;
    });
    if (openerCard && !this.closedByKeyboard) {
      // Pointer close: release focus so the card's focus-reveal doesn't pin
      // the button, and suppress hover effects on the card under the pointer
      // until it genuinely leaves (cleared on mouseleave only).
      opener.blur();
      if (this.lastPointerPosition) {
        const under = document.elementFromPoint(this.lastPointerPosition.x, this.lastPointerPosition.y);
        const card = under && under.closest('.card-wrapper');
        if (card) {
          card.classList.add('ws-qa-hover-reset');
          card.addEventListener('mouseleave', () => card.classList.remove('ws-qa-hover-reset'), { once: true });
        }
      }
    }
    this.closedByKeyboard = false;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
